import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createAtmType = ( {data} : {data: IPostNewAtmType | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/AtmTypes/InsertAtmType`, data);
};

type QueryFnType = typeof createAtmType;

type UseCreateAtmTypeOptions = {
  data: IPostNewAtmType | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateAtmType = ({ config }: UseCreateAtmTypeOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Τύπου.`, 500);
            console.error('Couldnt create new atm model', error);
            setIsNotificationVisible(true)
          },
          onSuccess: (response) => {
            queryClient.invalidateQueries(["getAllAtmTypes"])
            addNotification("Δημιουργήθηκε Νέος Τύπος.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createAtmType,
    })
}